import { useState, useEffect } from 'react'

/**
 * Debounces a value by the specified delay.
 *
 * Returns the debounced value which only updates after `delay` ms
 * of no changes to the input value. Useful for search inputs
 * to avoid firing API calls on every keystroke.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debouncedValue
}
